module.exports = __webpack_public_path__ + "static/img/xiugaiyinliang.dd071f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/xiugaiyinliang.png
// module id = 0sdB
// module chunks = 24